import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';

const KVKKPage = () => {
  useEffect(() => {
    document.title = 'KVKK Aydınlatma Metni | Karşıyaka Visa Consulting';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Karşıyaka Visa Consulting KVKK Aydınlatma Metni. Kişisel verilerinizin işlenmesi, korunması ve haklarınız hakkında detaylı bilgi.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-20">
        <section className="py-20 bg-cream-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
              <div className="mb-8">
                <Link to="/" className="inline-flex items-center text-navy-600 hover:text-navy-900 transition-colors mb-6 text-sm">
                  <i className="ri-arrow-left-line mr-2"></i>
                  Ana Sayfaya Dön
                </Link>
                <h1 className="font-display text-4xl md:text-5xl font-bold text-navy-900 mb-4">
                  KVKK Aydınlatma Metni
                </h1>
                <p className="text-navy-600">
                  Son Güncelleme: 1 Ocak 2025
                </p>
              </div>

              <div className="prose prose-navy max-w-none space-y-8 text-navy-700 leading-relaxed">
                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">1. Veri Sorumlusu</h2>
                  <p>
                    6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verileriniz; veri sorumlusu olarak 
                    <strong> Karşıyaka Visa Consulting</strong> (Tuna Mah. Kemalpaşa Cad. Kat:5/506 Ses İş Hanı Karşıyaka / İzmir) 
                    tarafından aşağıda açıklanan kapsamda işlenebilecektir.
                  </p>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">2. Kişisel Verilerin İşlenme Amacı</h2>
                  <p>
                    İzmir vize danışmanlığı hizmetlerimiz kapsamında toplanan kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
                  </p>
                  <ul className="list-disc pl-6 space-y-2 mt-4">
                    <li>Vize başvuru süreçlerinin yürütülmesi ve takibi</li>
                    <li>Müşteri ilişkileri yönetimi ve iletişim</li>
                    <li>Hukuki yükümlülüklerin yerine getirilmesi</li>
                    <li>Sözleşme süreçlerinin yürütülmesi</li>
                    <li>Randevu ve bilgilendirme hizmetlerinin sağlanması</li>
                    <li>İstatistiksel analiz ve raporlama</li>
                    <li>Müşteri memnuniyeti ölçümleme ve iyileştirme çalışmaları</li>
                    <li>Yasal düzenlemelere uyum sağlanması</li>
                  </ul>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">3. İşlenen Kişisel Veriler</h2>
                  <p>
                    İzmir vize danışmanlığı hizmetlerimiz kapsamında işlenen kişisel veri kategorileri:
                  </p>
                  <ul className="list-disc pl-6 space-y-2 mt-4">
                    <li><strong>Kimlik Bilgileri:</strong> Ad, soyad, T.C. kimlik numarası, pasaport numarası, doğum tarihi ve yeri</li>
                    <li><strong>İletişim Bilgileri:</strong> Telefon numarası, e-posta adresi, adres bilgileri</li>
                    <li><strong>Finansal Bilgiler:</strong> Banka hesap bilgileri, gelir durumu, ödeme bilgileri</li>
                    <li><strong>Mesleki Bilgiler:</strong> Meslek, çalışma durumu, işveren bilgileri</li>
                    <li><strong>Seyahat Bilgileri:</strong> Seyahat geçmişi, vize başvuru bilgileri</li>
                    <li><strong>Aile Bilgileri:</strong> Medeni durum, aile üyeleri bilgileri (aile birleşimi başvurularında)</li>
                    <li><strong>Görsel ve İşitsel Kayıtlar:</strong> Fotoğraf, ofis güvenlik kamera kayıtları</li>
                  </ul>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">4. Kişisel Verilerin Toplanma Yöntemi</h2>
                  <p>
                    Kişisel verileriniz, İzmir vize danışmanlığı hizmetlerimiz kapsamında:
                  </p>
                  <ul className="list-disc pl-6 space-y-2 mt-4">
                    <li>Web sitemiz üzerinden doldurduğunuz formlar aracılığıyla</li>
                    <li>Ofisimize yapılan başvurular sırasında</li>
                    <li>Telefon, e-posta ve WhatsApp iletişimleri yoluyla</li>
                    <li>Vize başvuru evraklarından</li>
                    <li>Sözleşme ve anlaşmalar kapsamında</li>
                    <li>Yasal yükümlülükler gereği resmi kurumlardan</li>
                  </ul>
                  <p className="mt-4">
                    toplanmaktadır.
                  </p>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">5. Kişisel Verilerin Aktarılması</h2>
                  <p>
                    Toplanan kişisel verileriniz, KVKK'nın 8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları 
                    çerçevesinde:
                  </p>
                  <ul className="list-disc pl-6 space-y-2 mt-4">
                    <li>Vize başvurusu yapılan ülkelerin konsoloslukları ve büyükelçiliklerine</li>
                    <li>Vize başvuru merkezlerine (VFS Global, TLScontact vb.)</li>
                    <li>Yasal yükümlülükler gereği kamu kurum ve kuruluşlarına</li>
                    <li>Hizmet aldığımız iş ortaklarımıza (çeviri, noter, kurye hizmetleri vb.)</li>
                    <li>Hukuki danışmanlarımıza</li>
                  </ul>
                  <p className="mt-4">
                    aktarılabilmektedir. Yurtdışına veri aktarımı, KVKK'nın 9. maddesi uyarınca gerçekleştirilmektedir.
                  </p>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">6. Kişisel Veri Toplamanın Hukuki Sebepleri</h2>
                  <p>
                    Kişisel verileriniz, KVKK'nın 5. ve 6. maddelerinde belirtilen aşağıdaki hukuki sebeplere dayanılarak işlenmektedir:
                  </p>
                  <ul className="list-disc pl-6 space-y-2 mt-4">
                    <li>Açık rızanızın bulunması</li>
                    <li>Sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması</li>
                    <li>Hukuki yükümlülüğün yerine getirilmesi</li>
                    <li>İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, veri sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu olması</li>
                  </ul>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">7. Kişisel Veri Sahibinin Hakları</h2>
                  <p>
                    KVKK'nın 11. maddesi uyarınca, kişisel veri sahipleri olarak aşağıdaki haklara sahipsiniz:
                  </p>
                  <ul className="list-disc pl-6 space-y-2 mt-4">
                    <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                    <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
                    <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                    <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme</li>
                    <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme</li>
                    <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerinizin silinmesini veya yok edilmesini isteme</li>
                    <li>Düzeltme, silme ve yok edilme işlemlerinin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
                    <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
                    <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
                  </ul>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">8. Başvuru Yöntemi</h2>
                  <p>
                    Yukarıda belirtilen haklarınızı kullanmak için kimliğinizi tespit edici gerekli bilgiler ile KVKK'nın 11. maddesinde 
                    belirtilen haklardan kullanmayı talep ettiğiniz hakkınıza yönelik açıklamalarınızı içeren talebinizi;
                  </p>
                  <ul className="list-disc pl-6 space-y-2 mt-4">
                    <li><strong>Yazılı olarak:</strong> Tuna Mah. Kemalpaşa Cad. Kat:5/506 Ses İş Hanı Karşıyaka / İzmir adresine</li>
                    <li><strong>E-posta ile:</strong> karsiyakavisaconsulting@gmail.com adresine</li>
                    <li><strong>Kayıtlı Elektronik Posta (KEP) ile:</strong> (KEP adresimiz varsa belirtilecek)</li>
                  </ul>
                  <p className="mt-4">
                    iletebilirsiniz. Başvurularınız, talebin niteliğine göre en kısa sürede ve en geç 30 (otuz) gün içinde 
                    ücretsiz olarak sonuçlandırılacaktır. İşlemin ayrıca bir maliyeti gerektirmesi hâlinde, Kişisel Verileri 
                    Koruma Kurulu tarafından belirlenen tarifedeki ücret alınabilir.
                  </p>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">9. Veri Güvenliği</h2>
                  <p>
                    Karşıyaka Visa Consulting olarak, İzmir vize danışmanlığı hizmetlerimiz kapsamında topladığımız kişisel verilerin 
                    güvenliğini sağlamak için gerekli teknik ve idari tedbirleri almaktayız. Kişisel verileriniz, yetkisiz erişime, 
                    kayba, kötüye kullanıma karşı korunmaktadır.
                  </p>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">10. Saklama Süresi</h2>
                  <p>
                    Kişisel verileriniz, işlendikleri amaç için gerekli olan süre boyunca ve yasal saklama yükümlülüklerimiz 
                    çerçevesinde saklanmaktadır. Vize başvuru süreçleri tamamlandıktan sonra, verileriniz yasal saklama 
                    süreleri (genellikle 10 yıl) boyunca arşivlenmekte, bu süre sonunda güvenli bir şekilde imha edilmektedir.
                  </p>
                </section>

                <section>
                  <h2 className="font-display text-2xl font-bold text-navy-900 mb-4">11. İletişim</h2>
                  <p>
                    KVKK Aydınlatma Metni ile ilgili sorularınız için bizimle iletişime geçebilirsiniz:
                  </p>
                  <div className="bg-cream-50 rounded-xl p-6 mt-4">
                    <p><strong>Karşıyaka Visa Consulting</strong></p>
                    <p>Adres: Tuna Mah. Kemalpaşa Cad. Kat:5/506 Ses İş Hanı Karşıyaka / İzmir</p>
                    <p>Telefon: +90 551 480 3007</p>
                    <p>E-posta: karsiyakavisaconsulting@gmail.com</p>
                  </div>
                </section>

                <section className="border-t border-navy-200 pt-8 mt-8">
                  <p className="text-sm text-navy-600">
                    Bu KVKK Aydınlatma Metni, yasal düzenlemelerdeki değişiklikler doğrultusunda güncellenebilir. 
                    Güncellemeler web sitemizde yayınlanacaktır.
                  </p>
                </section>
              </div>

              <div className="mt-12 pt-8 border-t border-navy-200">
                <Link
                  to="/"
                  className="inline-flex items-center text-navy-900 font-semibold hover:text-navy-700 transition-colors whitespace-nowrap"
                >
                  <i className="ri-arrow-left-line mr-2"></i>
                  Ana Sayfaya Dön
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default KVKKPage;